import React, { Fragment, useMemo, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Modal from '@tds/community-modal';

import { Error } from '../design/elements';
import FormField from './formField';
import {
  EquipmentSectionWrapper,
  EquipmentSectionTitle,
  EquipmentSectionSubTitle
} from './css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import stringInterpolation from '../utils/stringInterpolation';
import { getFieldValue } from './utils';
import {
  cameraTypeList,
  typePoeCamera,
  keyMonitorAdditionalEquipmentVulcan,
  keySecurityCameraEquipment,
  typeSwitch,
  keyProtectAdditionalEquipmentVulcan,
  keyControlAdditionalEquipmentVulcan,
  keyProtectIncludedEquipmentCameraSelectionVulcan,
  keyControlIncludedEquipmentCameraSelectionVulcan,
  secureBusinessOppositeSectionKeysVulcan,
  secureBusinessMaxCameraLimit,
  fivePortPoeSwitchVulcan,
  fivePortPoeSwitchPaidVulcan,
  easyThreeYearFivePortPoeSwitchVulcan,
  easyFiveYearFivePortPoeSwitchVulcan,
  easyThreeYearFivePortPoeSwitchPaidVulcan,
  easyFiveYearFivePortPoeSwitchPaidVulcan,
  easyFiveYearTemperatureProbeVulcan,
  protectIncludedPoeSwitchVulcan,
  controlIncludedPoeSwitchVulcan,
  fieldPoeSwitchIncludedEquipment,
  controlIncludedPaid2TbSvrVulcan,
  poeDomeCamera,
  easyThreeYearPoeDomeCameraVulcan,
  easyFiveYearPoeDomeCameraVulcan,
  temperatureSensorVulcan,
  temperatureProbeVulcan,
  easyThreeYearTemperatureSensorVulcan,
  easyThreeYearTemperatureProbeVulcan,
  protectIncludedPoeTurretCameraVulcan,
  controlIncludedPoeTurretCameraVulcan,
  easyFiveYearTemperatureSensorVulcan,
  controlIncludedIndoorCameraVulcan,
  controlIncludedOutdoorCameraVulcan,
  controlIncludedSdCardVulcan,
  indoorCameraVulcan,
  easyThreeYearIndoorCameraVulcan,
  easyFiveYearIndoorCameraVulcan,
  outdoorCameraVulcan,
  easyThreeYearOutdoorCameraVulcan,
  easyFiveYearOutdoorCameraVulcan,
  microSdCard128GbVulcan,
  easyThreeYearMicroSdCard128GbVulcan,
  easyFiveYearMicroSdCard128GbVulcan,
  controlIncludedCameraLimit,
} from '../utils/constant';

const EquipmentSectionForm = ({
  data,
  formErrors,
  formFields,
  setFormFields,
  isFormTouched,
  setIsFormTouched,
  equipmentTotalPrice,
  setEquipmentTotalPrice,
  hardwareDiscountAmount,
  setHadwareDiscountAmount,
  dueNow,
  setDueNow,
  isHardwareDiscount,
  renderTempSensor,
  setRenderTempSensor,
  isExpanded
}) => {
  const [isAlert, setIsAlertOpen] = useState(false);
  const [bodyText, setBodyText] = useState('');

  const {
    name,
    title,
    subTitle,
    maxValue,
    isLimitCameraOnly,
    formStepFields,
    oneTimePaymentTitle,
    oneTimePaymentTitleVulcan,
    threeYearEasyPaymentTitle,
    fiveYearEasyPaymentTitle,
    easyPaymentTitle,
    easyPaymentFields,
    threeYearEasyPaymentFields,
    fiveYearEasyPaymentFields,
    oneTimePaymentFields
  } = data;

  let finalFields;
  if (Array.isArray(formStepFields) && Array.isArray(easyPaymentFields)) {
    finalFields = [...formStepFields, ...easyPaymentFields];
  } else if (
    Array.isArray(oneTimePaymentFields) &&
    Array.isArray(threeYearEasyPaymentFields) &&
    Array.isArray(fiveYearEasyPaymentFields)
  ) {
    finalFields = [
      ...oneTimePaymentFields,
      ...threeYearEasyPaymentFields,
      ...fiveYearEasyPaymentFields
    ];
  } else {
    finalFields = formStepFields;
  }

  const radioSelection = name.slice(0, 7);
  const getObjectValue = (obj, path) => _.get(obj, `${path}.value`, 0);
  const setObjectValue = (obj, path, value, key = 'value') => _.set(obj, `${path}.${key}`, value);
  const localizedStrings = useLocalizedStringsContext();
  const {
    fieldPlusMinus: { errorMessage },
    secureBusiness: { maxCameraLimitErrorMessage }
  } = localizedStrings;

  const checkIfHasSwitchOption = () => {
    const isSwitch =
      formFields[name] &&
      (Object.prototype.hasOwnProperty.call(
        formFields[name],
        fivePortPoeSwitchVulcan
      ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          fivePortPoeSwitchPaidVulcan
        ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          fieldPoeSwitchIncludedEquipment
        ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          temperatureProbeVulcan
        ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          easyThreeYearFivePortPoeSwitchVulcan
        ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          easyThreeYearFivePortPoeSwitchPaidVulcan
        ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          easyThreeYearTemperatureProbeVulcan
        ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          easyFiveYearFivePortPoeSwitchVulcan
        ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          easyFiveYearFivePortPoeSwitchPaidVulcan
        ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          easyFiveYearTemperatureProbeVulcan
        ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          protectIncludedPoeSwitchVulcan
        ) ||
        Object.prototype.hasOwnProperty.call(
          formFields[name],
          controlIncludedPoeSwitchVulcan
        ));
    return isSwitch;
  };

  const formObjectKeys = useMemo(
    () =>
      finalFields.reduce((acc, { fields: { name: formName } }) => {
        acc.push(formName);
        return acc;
      }, []),
    [formStepFields]
  );

  useEffect(() => {
    // Calc initial prices
    const fields = { ...formFields[name] } || {};
    if (fields) {
      const sumForSection = formObjectKeys
        .filter(kf => (fields[kf] || {}).isVisible)
        .reduce((acc, kn) => {
          const val =
            parseInt((fields[kn] || {}).value || 0, 10) *
              (fields[kn] || {}).price || 0;
          return acc + val;
        }, 0);
      const sumForMonthly = formObjectKeys
        .filter(kf => (fields[kf] || {}).isVisible)
        .reduce((acc, kn) => {
          const val =
            parseInt((fields[kn] || {}).value || 0, 10) *
              (fields[kn] || {}).monthlyPayment || 0;
          return acc + val;
        }, 0);
      const sumForOneTime = formObjectKeys
        .filter(kf => (fields[kf] || {}).isVisible)
        .reduce((acc, kn) => {
          const val =
            parseInt((fields[kn] || {}).value || 0, 10) *
              (fields[kn] || {}).oneTimePayment || 0;
          return acc + val;
        }, 0);
      const currentPrice = equipmentTotalPrice.addAmountToPrice;
      const newPrice = currentPrice + sumForSection;
      const currentMonthlyPayment = equipmentTotalPrice.addAmountToMonthly;
      let newMonthlyPayment = currentMonthlyPayment + sumForMonthly;
      // SOF-1768
      const valueTempSensor = getFieldValue(temperatureSensorVulcan, fields);
      if (valueTempSensor > 0) {
        newMonthlyPayment += 5;
      }
      if (valueTempSensor > 5) {
        newMonthlyPayment += 5;
      }
      const valueEasyTempSensor = getFieldValue(
        easyThreeYearTemperatureSensorVulcan,
        fields
      );
      if (valueEasyTempSensor > 0) {
        newMonthlyPayment += 5;
      }
      if (valueEasyTempSensor > 5) {
        newMonthlyPayment += 5;
      }
      if (valueTempSensor > 0 && valueEasyTempSensor > 0) {
        newMonthlyPayment -= 5;
      }
      if (
        [
          keyControlAdditionalEquipmentVulcan,
          keyProtectAdditionalEquipmentVulcan,
          keyMonitorAdditionalEquipmentVulcan
        ].includes(name)
      ) {
        let discountAmount = 0;
        if (newPrice >= 200) {
          discountAmount = 200;
        } else if (newPrice > 0) {
          discountAmount = newPrice;
        }
        if (isHardwareDiscount) setDueNow(dueNow + hardwareDiscountAmount);
        setHadwareDiscountAmount(discountAmount);
      }
      setEquipmentTotalPrice({
        subtractAmountFromPrice: currentPrice,
        addAmountToPrice: newPrice,
        subtractAmountFromMonthly: currentMonthlyPayment,
        addAmountToMonthly: newMonthlyPayment
      });
    }
  }, []);

  const checkIfTotalOverLimit = (opt, fieldProductType) => {
    const returnObj = {
      totalOverLimit: false,
      isCameraLimit: false
    };

    if ([
        keyProtectIncludedEquipmentCameraSelectionVulcan,
        keyProtectAdditionalEquipmentVulcan,
        keyControlIncludedEquipmentCameraSelectionVulcan,
        keyControlAdditionalEquipmentVulcan,
        keyMonitorAdditionalEquipmentVulcan
      ].includes(name)
      && cameraTypeList.includes(fieldProductType)) {
      const otherSectionKey = secureBusinessOppositeSectionKeysVulcan[name];
      const otherSection = { ...formFields[otherSectionKey] };
      const otherSectionSum = Object.keys(otherSection)
        .filter(ko =>
          cameraTypeList.includes((otherSection[ko] || {}).productType)
        )
        .reduce(
          (acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10),
          0
        );
      const currentSum = formObjectKeys
        .filter(key => cameraTypeList.includes(opt[key].productType))
        .reduce((acc, key) => acc + parseInt(opt[key].value || 0, 10), 0);

      if (otherSectionSum + currentSum > secureBusinessMaxCameraLimit) {
        returnObj.totalOverLimit = true;
        returnObj.isCameraLimit = true;
        const text = stringInterpolation(
          returnObj.isCameraLimit ? maxCameraLimitErrorMessage : errorMessage,
          returnObj.isCameraLimit ? secureBusinessMaxCameraLimit : maxValue
        );
        setIsAlertOpen(true);
        setBodyText(text);
        return returnObj;
      }
      if ([
          keyProtectIncludedEquipmentCameraSelectionVulcan,
          keyControlIncludedEquipmentCameraSelectionVulcan
        ].includes(name)
        && typeof maxValue === 'number') {
        const sectionSum = formObjectKeys
          .filter(k => opt[k].productType !== typeSwitch)
          .reduce((acc, k) => acc + parseInt(opt[k].value || 0, 10), 0);
        if (sectionSum > maxValue) {
          returnObj.totalOverLimit = true;
          returnObj.isCameraLimit = false;
          const text = stringInterpolation(
            returnObj.isCameraLimit ? maxCameraLimitErrorMessage : errorMessage,
            returnObj.isCameraLimit ? secureBusinessMaxCameraLimit : maxValue
          );
          setIsAlertOpen(true);
          setBodyText(text);
          return returnObj;
        }
      }
    } else if (typeof maxValue === 'number' && !isLimitCameraOnly) {
      const currentSum = formObjectKeys
        .filter(k => opt[k].productType !== typeSwitch)
        .reduce((acc, k) => acc + parseInt(opt[k].value || 0, 10), 0);
      if (currentSum > maxValue) {
        returnObj.totalOverLimit = true;
        returnObj.isCameraLimit = false;
        const text = stringInterpolation(
          returnObj.isCameraLimit ? maxCameraLimitErrorMessage : errorMessage,
          returnObj.isCameraLimit ? secureBusinessMaxCameraLimit : maxValue
        );
        setIsAlertOpen(true);
        setBodyText(text);
        return returnObj;
      }
    }
    if (
      [
        keyProtectAdditionalEquipmentVulcan,
        keyControlAdditionalEquipmentVulcan,
        keyMonitorAdditionalEquipmentVulcan
      ].includes(name) &&
      fieldProductType === 'Probe'
    ) {
      const otherSectionKey = secureBusinessOppositeSectionKeysVulcan[name];
      const otherSection = { ...formFields[otherSectionKey] };
      const otherSectionSum = Object.keys(otherSection)
        .filter(ko => 'Probe'.includes((otherSection[ko] || {}).productType))
        .reduce(
          (acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10),
          0
        );
      const currentSum = formObjectKeys
        .filter(key => 'Probe'.includes(opt[key].productType))
        .reduce((acc, key) => acc + parseInt(opt[key].value || 0, 10), 0);
      if (otherSectionSum + currentSum > 10) {
        returnObj.totalOverLimit = true;
        returnObj.isCameraLimit = true;
        const text = stringInterpolation(
          'A maximum of %s temperature sensors can be selected in total',
          10
        );
        setIsAlertOpen(true);
        setBodyText(text);
        return returnObj;
      }
    }

    return returnObj;
  };

  const getControlIncludedCameraTotal = (opt, fieldProductType) => {
    const returnObj = {
      controlIncludedCameraTotalOverLimit: false,
      isControlCameraLimit: false
    };

    if (
      [keyControlIncludedEquipmentCameraSelectionVulcan].includes(name) &&
      cameraTypeList.includes(fieldProductType)
    ) {
      const sectionSum = formObjectKeys
        .filter(k => cameraTypeList.includes(opt[k].productType))
        .reduce((acc, k) => acc + parseInt(opt[k].value || 0, 10), 0);
      if (sectionSum > 2) {
        returnObj.controlIncludedCameraTotalOverLimit = true;
        const text = stringInterpolation(
          returnObj.isControlCameraLimit
            ? maxCameraLimitErrorMessage
            : errorMessage,
          returnObj.isControlCameraLimit
            ? secureBusinessMaxCameraLimit
            : controlIncludedCameraLimit
        );
        setIsAlertOpen(true);
        setBodyText(text);
        return returnObj;
      }
    }
    return returnObj; // Ensure returnObj is always returned
  };

  const getCameraTotal = (
    fieldProductType,
    overallCount,
    easyCount,
    oneTimeCount
  ) => {
    let count = 0;
    if (
      [
        keyProtectIncludedEquipmentCameraSelectionVulcan,
        keyProtectAdditionalEquipmentVulcan,
        keyControlIncludedEquipmentCameraSelectionVulcan,
        keyControlAdditionalEquipmentVulcan
      ].includes(name) &&
      typePoeCamera.includes(fieldProductType)
    ) {
      const otherSectionKey = secureBusinessOppositeSectionKeysVulcan[name];
      const otherSection = { ...formFields[otherSectionKey] };
      if (overallCount) {
        const paymentSectionSum = Object.keys(otherSection)
          .filter(ko => {
            return typePoeCamera === (otherSection[ko] || {}).productType;
          })
          .reduce(
            (acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10),
            0
          );
        count = paymentSectionSum;
      }
      if (easyCount) {
        const paymentSectionSum = Object.keys(otherSection)
          .filter(ko => {
            return (
              typePoeCamera === (otherSection[ko] || {}).productType &&
              ko.includes('easy')
            );
          })
          .reduce(
            (acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10),
            0
          );
        count = paymentSectionSum;
      }
      if (oneTimeCount) {
        const paymentSectionSum = Object.keys(otherSection)
          .filter(ko => {
            return (
              typePoeCamera === (otherSection[ko] || {}).productType &&
              !ko.includes('easy')
            );
          })
          .reduce(
            (acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10),
            0
          );
        count = paymentSectionSum;
      }
    }
    return count;
  };

  const calculateEquipmentRates = (oldValues, newValues, fieldName) => {
    const oldSumForSection = formObjectKeys.reduce(
      (acc, ko) =>
        acc + parseInt(oldValues[ko].value || 0, 10) * oldValues[ko].price || 0,
      0
    );
    const newSumForSection = formObjectKeys.reduce(
      (acc, kn) =>
        acc + parseInt(newValues[kn].value || 0, 10) * newValues[kn].price || 0,
      0
    );
    const newSumForDueMonthly = formObjectKeys.reduce(
      (acc, kn) =>
        acc +
          parseInt(newValues[kn].value || 0, 10) *
            newValues[kn].monthlyPayment || 0,
      0
    );
    const oldSumForDueMonthly = formObjectKeys.reduce(
      (acc, kn) =>
        acc +
          parseInt(oldValues[kn].value || 0, 10) *
            oldValues[kn].monthlyPayment || 0,
      0
    );

    const currentPrice = equipmentTotalPrice.addAmountToPrice;
    const newPrice = currentPrice + (newSumForSection - oldSumForSection);
    const currentMonthlyPayment = equipmentTotalPrice.addAmountToMonthly || 0;
    let newMonthlyPayment =
      currentMonthlyPayment + (newSumForDueMonthly - oldSumForDueMonthly);

    if (
      [
        keyProtectAdditionalEquipmentVulcan,
        keyControlAdditionalEquipmentVulcan,
        keyMonitorAdditionalEquipmentVulcan
      ].includes(name)
    ) {
      // Temperature Sensor Pricing
      if (
        fieldName === temperatureSensorVulcan &&
        (newValues.easyThreeYearTemperatureSensorVulcan.value === undefined ||
          newValues.easyThreeYearTemperatureSensorVulcan.value === 0)
      ) {
        if (oldValues.temperatureSensorVulcan.value === undefined) {
          // eslint-disable-next-line no-param-reassign
          oldValues.temperatureSensorVulcan.value = 0;
        }
        // increase
        if (
          newValues.temperatureSensorVulcan.value >
          oldValues.temperatureSensorVulcan.value
        ) {
          if (
            newValues.temperatureSensorVulcan.value === 1 ||
            newValues.temperatureSensorVulcan.value === 6
          ) {
            newMonthlyPayment += 5;
          }
        } // decrease
        else if (
          newValues.temperatureSensorVulcan.value <
          oldValues.temperatureSensorVulcan.value
        ) {
          if (
            newValues.temperatureSensorVulcan.value === 0 ||
            newValues.temperatureSensorVulcan.value === 5
          ) {
            newMonthlyPayment -= 5;
          }
        }
      } else if (
        fieldName === easyThreeYearTemperatureSensorVulcan &&
        (newValues.temperatureSensorVulcan.value === undefined ||
          newValues.temperatureSensorVulcan.value === 0)
      ) {
        if (oldValues.easyThreeYearTemperatureSensorVulcan.value === undefined)
          // eslint-disable-next-line no-param-reassign
          oldValues.easyThreeYearTemperatureSensorVulcan.value = 0;
        // increase
        if (
          newValues.easyThreeYearTemperatureSensorVulcan.value >
          oldValues.easyThreeYearTemperatureSensorVulcan.value
        ) {
          if (
            newValues.easyThreeYearTemperatureSensorVulcan.value === 1 ||
            newValues.easyThreeYearTemperatureSensorVulcan.value === 6
          ) {
            newMonthlyPayment += 5;
          }
        } // decrease
        else if (
          newValues.easyThreeYearTemperatureSensorVulcan.value <
          oldValues.easyThreeYearTemperatureSensorVulcan.value
        ) {
          if (
            newValues.easyThreeYearTemperatureSensorVulcan.value === 0 ||
            newValues.easyThreeYearTemperatureSensorVulcan.value === 5
          ) {
            newMonthlyPayment -= 5;
          }
        }
      } else if (
        (fieldName === easyThreeYearTemperatureSensorVulcan &&
          (newValues.temperatureSensorVulcan.value !== undefined ||
            newValues.temperatureSensorVulcan.value !== 0)) ||
        (fieldName === temperatureSensorVulcan &&
          (newValues.easyThreeYearTemperatureSensorVulcan.value !== undefined ||
            newValues.easyThreeYearTemperatureSensorVulcan.value !== 0))
      ) {
        if (
          fieldName === temperatureSensorVulcan ||
          fieldName === easyThreeYearTemperatureSensorVulcan
        ) {
          if (
            newValues.temperatureSensorVulcan.value >
              oldValues.temperatureSensorVulcan.value ||
            newValues.easyThreeYearTemperatureSensorVulcan.value >
              oldValues.easyThreeYearTemperatureSensorVulcan.value
          ) {
            if (
              newValues.temperatureSensorVulcan.value +
                newValues.easyThreeYearTemperatureSensorVulcan.value ===
                1 ||
              newValues.temperatureSensorVulcan.value +
                newValues.easyThreeYearTemperatureSensorVulcan.value ===
                6
            ) {
              newMonthlyPayment += 5;
            }
          } // decrease
          else if (
            newValues.temperatureSensorVulcan.value <
              oldValues.temperatureSensorVulcan.value ||
            newValues.easyThreeYearTemperatureSensorVulcan.value <
              oldValues.easyThreeYearTemperatureSensorVulcan.value
          ) {
            if (
              newValues.temperatureSensorVulcan.value +
                newValues.easyThreeYearTemperatureSensorVulcan.value ===
                0 ||
              newValues.temperatureSensorVulcan.value +
                newValues.easyThreeYearTemperatureSensorVulcan.value ===
                5
            ) {
              newMonthlyPayment -= 5;
            }
          }
        }
      }
    }

    if (
      [
        keyControlAdditionalEquipmentVulcan,
        keyProtectAdditionalEquipmentVulcan,
        keyMonitorAdditionalEquipmentVulcan
      ].includes(name)
    ) {
      let discountAmount = 0;
      if (newPrice >= 200) {
        discountAmount = 200;
      } else if (newPrice > 0) {
        discountAmount = newPrice;
      }
      if (isHardwareDiscount) setDueNow(dueNow + hardwareDiscountAmount);
      setHadwareDiscountAmount(discountAmount);
    }
    setEquipmentTotalPrice({
      subtractAmountFromPrice: currentPrice || 0,
      addAmountToPrice: newPrice || 0,
      addAmountToMonthly: newMonthlyPayment || 0,
      subtractAmountFromMonthly: currentMonthlyPayment || 0
    });
  };

  // Function to calculate temperature sensors based on key names
  const countTemperatureSensorAll = inputKeys => {
    let tempSensorCount = 0;

    // Ensure inputKeys is an array
    let keys = [];
    if (Array.isArray(inputKeys)) {
      keys = inputKeys;
    } else if (typeof inputKeys === 'string') {
      keys = [inputKeys];
    }

    keys.forEach(key => {
      if (radioSelection === 'monitor') {
        if (key === 'oneTimePayment') {
          tempSensorCount += getObjectValue(formFields, `${keyMonitorAdditionalEquipmentVulcan}.${temperatureSensorVulcan}`);
        }
        if (key === 'threeYearEasyPayment') {
          tempSensorCount += getObjectValue(formFields, `${keyMonitorAdditionalEquipmentVulcan}.${easyThreeYearTemperatureSensorVulcan}`);
        }
        if (key === 'fiveYearEasyPayment') {
          tempSensorCount += getObjectValue(formFields, `${keyMonitorAdditionalEquipmentVulcan}.${easyFiveYearTemperatureSensorVulcan}`);
        }
      }

      if (radioSelection === 'protect') {
        if (key === 'oneTimePayment') {
          tempSensorCount += getObjectValue(formFields, `${keyProtectAdditionalEquipmentVulcan}.${temperatureSensorVulcan}`);
        }
        if (key === 'threeYearEasyPayment') {
          tempSensorCount += getObjectValue(formFields, `${keyProtectAdditionalEquipmentVulcan}.${easyThreeYearTemperatureSensorVulcan}`);
        }
        if (key === 'fiveYearEasyPayment') {
          tempSensorCount += getObjectValue(formFields, `${keyProtectAdditionalEquipmentVulcan}.${easyFiveYearTemperatureSensorVulcan}`);
        }
      }

      if (radioSelection === 'control') {
        if (key === 'oneTimePayment') {
          tempSensorCount += getObjectValue(formFields, `${keyControlAdditionalEquipmentVulcan}.${temperatureSensorVulcan}`);
        }
        if (key === 'threeYearEasyPayment') {
          tempSensorCount += getObjectValue(formFields, `${keyControlAdditionalEquipmentVulcan}.${easyThreeYearTemperatureSensorVulcan}`);
        }
        if (key === 'fiveYearEasyPayment') {
          tempSensorCount += getObjectValue(formFields, `${keyControlAdditionalEquipmentVulcan}.${easyFiveYearTemperatureSensorVulcan}`);
        }
      }
    });
    return tempSensorCount;
  };

  const [temperatureSensorCountAll, setTemperatureSensorCountAll] = useState(0);

  useEffect(() => {
    setTemperatureSensorCountAll(
      countTemperatureSensorAll([
        'oneTimePayment',
        'threeYearEasyPayment',
        'fiveYearEasyPayment'
      ])
    );
  }, [formFields]);

  useEffect(() => {
    // Logic to update form fields based on the temperatureSensorCountAll
    const fields = { ...formFields };
    if (
      temperatureSensorCountAll < 1 ||
      temperatureSensorCountAll === undefined
    ) {
      if (radioSelection === 'monitor') {
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.isVisible = false;
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.isVisible = false;
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.value = 0;
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.value = 0;
      }
      if (radioSelection === 'protect') {
        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.isVisible = false;

        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.isVisible = false;
        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.value = 0;
        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.value = 0;
      }
      if (radioSelection === 'control') {
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.isVisible = false;
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.isVisible = false;
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.value = 0;
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.value = 0;
      }
    } else if (temperatureSensorCountAll < 6) {
      if (radioSelection === 'monitor') {
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.isVisible = true;
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.isVisible = false;
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.value = 1;
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.value = 0;
      }
      if (radioSelection === 'protect') {
        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.isVisible = true;

        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.isVisible = false;
        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.value = 1;
        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.value = 0;
      }
      if (radioSelection === 'control') {
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.isVisible = true;
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.isVisible = false;
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.value = 1;
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.value = 0;
      }
    } else if (temperatureSensorCountAll > 5) {
      if (radioSelection === 'monitor') {
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.isVisible = false;
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.isVisible = true;
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.value = 0;
        fields[
          keyMonitorAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.value = 1;
      }
      if (radioSelection === 'protect') {
        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.isVisible = false;

        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.isVisible = true;
        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.value = 0;
        fields[
          keyProtectAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.value = 1;
      }
      if (radioSelection === 'control') {
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.isVisible = false;
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.isVisible = true;
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringFiveDollarVulcan.value = 0;
        fields[
          keyControlAdditionalEquipmentVulcan
        ].temperatureMonitoringTenDollarVulcan.value = 1;
      }
    }
    setRenderTempSensor(!renderTempSensor);
  }, [temperatureSensorCountAll]);
 
  // eslint-disable-next-line consistent-return
  const handleFormField = ({ name: fieldName, value }) => {
    if ([
      controlIncludedSdCardVulcan,
      microSdCard128GbVulcan,
      easyThreeYearMicroSdCard128GbVulcan,
      easyFiveYearMicroSdCard128GbVulcan,
      temperatureProbeVulcan,
      temperatureProbeVulcan,
      easyThreeYearTemperatureProbeVulcan,
      easyFiveYearTemperatureProbeVulcan,
      controlIncludedPaid2TbSvrVulcan
    ].includes(fieldName)) {
      return null;
    }

    const fields = _.cloneDeep(formFields);
    const oldValues = _.cloneDeep(formFields[name]);

    const checkAllPoeCameraValues = () => {
      let result;

      switch (radioSelection) {
        case 'control':
          result = getObjectValue(fields, `${keyControlIncludedEquipmentCameraSelectionVulcan}.${controlIncludedPoeTurretCameraVulcan}`) > 0 ||
            getObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.${poeDomeCamera}`) > 0 ||
            getObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.${easyThreeYearPoeDomeCameraVulcan}`) > 0 ||
            getObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.${easyFiveYearPoeDomeCameraVulcan}`) > 0;
          break;
        case 'protect':
          result = getObjectValue(fields, `${keyProtectIncludedEquipmentCameraSelectionVulcan}.${protectIncludedPoeTurretCameraVulcan}`) > 0 ||
            getObjectValue(fields, `${keyProtectAdditionalEquipmentVulcan}.${poeDomeCamera}`) > 0 ||
            getObjectValue(fields, `${keyProtectAdditionalEquipmentVulcan}.${easyThreeYearPoeDomeCameraVulcan}`) > 0 ||
            getObjectValue(fields, `${keyProtectAdditionalEquipmentVulcan}.${easyFiveYearPoeDomeCameraVulcan}`) > 0;
          break;
        default:
          result = false;
      }

      return result;
    };

    fields[name][fieldName] = {
      ...fields[name][fieldName],
      value: parseInt(value, 10)
    };

    const countAllPoeCamera = () => {
      let result;

      switch (radioSelection) {
        case 'control':
          result =
            getObjectValue(fields, `${keyControlIncludedEquipmentCameraSelectionVulcan}.${controlIncludedPoeTurretCameraVulcan}`) +
            getObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.${poeDomeCamera}`) +
            getObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.${easyThreeYearPoeDomeCameraVulcan}`) +
            getObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.${easyFiveYearPoeDomeCameraVulcan}`);
          break;
        default:
          result = 0;
      }

      return result;
    };

    const poeCameraCountAll = countAllPoeCamera();

    const setSdCard = (obj) => {
      if (radioSelection === 'control') {
        const controlIncludedPaid2TbSvrVulcanValue = getObjectValue(obj, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedPaid2TbSvrVulcan`);
        const cameraSum =
          parseInt(getObjectValue(obj, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedIndoorCameraVulcan`), 10) +
          parseInt(getObjectValue(obj, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedOutdoorCameraVulcan`), 10);
        if (cameraSum > 0 && !(controlIncludedPaid2TbSvrVulcanValue >= 1)) {
          setObjectValue(obj, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedSdCardVulcan`, cameraSum);
        } else if (cameraSum === 0 || controlIncludedPaid2TbSvrVulcanValue >= 1) {
          setObjectValue(obj, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedSdCardVulcan`, 0);
        }
      }
    };

    const fieldProductType = fields[name][fieldName].productType;

    const { totalOverLimit } = checkIfTotalOverLimit(fields[name], fieldProductType);
    const { controlIncludedCameraTotalOverLimit } = getControlIncludedCameraTotal(fields[name], fieldProductType);

    if (!totalOverLimit && !controlIncludedCameraTotalOverLimit) {
      if (!isFormTouched) {
        setIsFormTouched(true);
      }
      if (checkIfHasSwitchOption() && !fieldName.startsWith('easy')) {
        const poeCameraCount = formObjectKeys
          .filter(
            kc =>
              fields[name][kc].productType === typePoeCamera &&
              !kc.startsWith('easy')
          )
          .reduce(
            (acc, kc) => acc + parseInt(fields[name][kc].value || 0, 10),
            0
          );
        const switchKey = formObjectKeys.filter(k => {
          return (
            fields[name][k].productType === typeSwitch &&
            fields[name][k].name === fivePortPoeSwitchVulcan
          );
        });

        if (switchKey.length > 0) {
          for (let i = 0; i < switchKey.length; i += 1) {
            fields[name][switchKey[i]].isVisible = poeCameraCount > 0 && poeCameraCount < 5;
            fields[name][switchKey[i]].value = poeCameraCount > 0 && poeCameraCount < 5 ? 1 : 0;
          }
          fields[keyControlIncludedEquipmentCameraSelectionVulcan][controlIncludedPaid2TbSvrVulcan].value = poeCameraCountAll > 0 ? 1 : 0;
          setSdCard(fields);
        }
        const includedSwitchKey = formObjectKeys.filter(k => {
          return (
            fields[name][k].productType === typeSwitch &&
            fields[name][k].name === protectIncludedPoeSwitchVulcan
          );
        });
        const additionalEquipmentPoeCameraArray = [
          protectIncludedPoeTurretCameraVulcan,
          controlIncludedPoeTurretCameraVulcan
        ];
        if (
          additionalEquipmentPoeCameraArray.includes(fieldName) &&
          value > 0
        ) {
          if (radioSelection === 'protect') {
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.isVisible = true;
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.value = 1;
          } else {
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.value = 0;
          }
          if (radioSelection === 'control') {
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.isVisible = true;
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.value = 1;
          } else {
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.value = 0;
          }
        }
        // 2TB SVR addition with Poe Turret Camera
        if (fieldName === controlIncludedPoeTurretCameraVulcan) {
          if (radioSelection === 'control') {
            if (value > 0) {
              fields[
                keyControlIncludedEquipmentCameraSelectionVulcan
              ].controlIncludedPaid2TbSvrVulcan.value = 1;
              fields[
                keyControlIncludedEquipmentCameraSelectionVulcan
              ].controlIncludedPaid2TbSvrVulcan.isVisible = true;
            } else if((value === 0 || value !== 0 ) && poeCameraCountAll === 0) {
                fields[
                    keyControlIncludedEquipmentCameraSelectionVulcan
                ].controlIncludedPaid2TbSvrVulcan.value = 0;  
              }
          }
        }
        // Adding SD Card equal qty to indoor/outdoor camera
        // if turret camera is added then sd cards are not added,
        // if no turret camera thenf sd cards are added with indoor/outdoor control camera

        if (
          [
            controlIncludedIndoorCameraVulcan,
            controlIncludedOutdoorCameraVulcan,
            controlIncludedPoeTurretCameraVulcan
          ].includes(fieldName)
        ) {
          const controlIncludedPoeTurretCameraValue = getObjectValue(fields, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedPaid2TbSvrVulcan`);
          if (radioSelection === 'control') {
            const cameraSum =
              parseInt(getObjectValue(fields, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedIndoorCameraVulcan`), 10) +
              parseInt(getObjectValue(fields, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedOutdoorCameraVulcan`), 10);
            if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
              setObjectValue(fields, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedSdCardVulcan`, cameraSum);
            } else if (cameraSum === 0 || controlIncludedPoeTurretCameraValue >= 1) {
              setObjectValue(fields, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedSdCardVulcan`, 0);
            }
          }
        }

        // add  sd card to additional control equipment
        if ([
            indoorCameraVulcan,
            outdoorCameraVulcan,
            controlIncludedPoeTurretCameraVulcan
          ].includes(fieldName)) {
          const controlIncludedPoeTurretCameraValue = getObjectValue(fields, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedPaid2TbSvrVulcan`);
          if (radioSelection === 'control') {
            const cameraSum =
              parseInt(getObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.indoorCameraVulcan`), 10) +
              parseInt(getObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.outdoorCameraVulcan`), 10);
            if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
              setObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.microSdCard128GbVulcan`, cameraSum);
            } else if (cameraSum === 0 || controlIncludedPoeTurretCameraValue >= 1) {
              setObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.microSdCard128GbVulcan`, 0);
            }
          }
        }

        if ([
            easyFiveYearIndoorCameraVulcan,
            easyFiveYearOutdoorCameraVulcan,
            controlIncludedPoeTurretCameraVulcan
          ].includes(fieldName)) {
          const controlIncludedPoeTurretCameraValue = getObjectValue(fields, `${keyControlIncludedEquipmentCameraSelectionVulcan}.controlIncludedPaid2TbSvrVulcan`);

          if (radioSelection === 'control') {
            const cameraSum =
              parseInt(getObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.easyFiveYearIndoorCameraVulcan`), 10) +
              parseInt(getObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.easyFiveYearOutdoorCameraVulcan`), 10);
            if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
              setObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.easyFiveYearMicroSdCard128GbVulcan`, cameraSum);
            } else if (cameraSum === 0 || controlIncludedPoeTurretCameraValue >= 1) {
              setObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.easyFiveYearMicroSdCard128GbVulcan`, 0);
            }
          }
        }

        // Temperature Probe Visiblity
        const additionalEquipmentTempSensorArray = [
          temperatureSensorVulcan,
          easyThreeYearTemperatureSensorVulcan,
          easyFiveYearTemperatureSensorVulcan
        ];
        if (additionalEquipmentTempSensorArray.includes(fieldName) && value > 0) {
          if (radioSelection === 'protect') {
            setObjectValue(fields, `${keyProtectAdditionalEquipmentVulcan}.temperatureProbeVulcan`, true, 'isVisible');
            setObjectValue(fields, `${keyProtectAdditionalEquipmentVulcan}.temperatureProbeVulcan`, value);
          }
          if (radioSelection === 'control') {
            setObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.temperatureProbeVulcan`, true, 'isVisible');
            setObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.temperatureProbeVulcan`, value);
          }
          if (radioSelection === 'monitor') {
            setObjectValue(fields, `${keyMonitorAdditionalEquipmentVulcan}.temperatureProbeVulcan`, true, 'isVisible');
            setObjectValue(fields, `${keyMonitorAdditionalEquipmentVulcan}.temperatureProbeVulcan`, value);
          }
        }
        if (additionalEquipmentTempSensorArray.includes(fieldName) && value < 1) {
          if (radioSelection === 'protect') {
            setObjectValue(fields, `${keyProtectAdditionalEquipmentVulcan}.temperatureProbeVulcan`, false, 'isVisible');
            setObjectValue(fields, `${keyProtectAdditionalEquipmentVulcan}.temperatureProbeVulcan`, 0);
          }
          if (radioSelection === 'control') {
            setObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.temperatureProbeVulcan`, false, 'isVisible');
            setObjectValue(fields, `${keyControlAdditionalEquipmentVulcan}.temperatureProbeVulcan`, 0);
          }
          if (radioSelection === 'monitor') {
            setObjectValue(fields, `${keyMonitorAdditionalEquipmentVulcan}.temperatureProbeVulcan`, false, 'isVisible');
            setObjectValue(fields, `${keyMonitorAdditionalEquipmentVulcan}.temperatureProbeVulcan`, 0);
          }
        }
        if (includedSwitchKey.length > 0) {
          const hidePoeIncludedCamera = checkAllPoeCameraValues();
          if (!hidePoeIncludedCamera) {
            for (let i = 0; i < includedSwitchKey.length; i += 1) {
              fields[name][includedSwitchKey[i]].isVisible = poeCameraCount > 0;
              fields[name][includedSwitchKey[i]].value = poeCameraCount > 0 ? 1 : 0;
            }
          }
          if (poeCameraCount + getCameraTotal(fieldProductType, undefined, true, undefined) >= 5) {
            setObjectValue(fields, `${secureBusinessOppositeSectionKeysVulcan[name]}.${easyThreeYearFivePortPoeSwitchPaidVulcan}`, true, 'isVisible');
            setObjectValue(fields, `${secureBusinessOppositeSectionKeysVulcan[name]}.${easyThreeYearFivePortPoeSwitchPaidVulcan}`, 1);
          }
          if (poeCameraCount + getCameraTotal(fieldProductType, undefined, undefined, true) >= 5) {
            setObjectValue(fields, `${secureBusinessOppositeSectionKeysVulcan[name]}.${fivePortPoeSwitchPaidVulcan}`, true, 'isVisible');
            setObjectValue(fields, `${secureBusinessOppositeSectionKeysVulcan[name]}.${fivePortPoeSwitchPaidVulcan}`, 1);
          }
          if (poeCameraCount + getCameraTotal(fieldProductType, undefined, true, undefined) < 5) {
            setObjectValue(fields, `${secureBusinessOppositeSectionKeysVulcan[name]}.${easyThreeYearFivePortPoeSwitchPaidVulcan}`, undefined, 'isVisible');
            setObjectValue(fields, `${secureBusinessOppositeSectionKeysVulcan[name]}.${easyThreeYearFivePortPoeSwitchPaidVulcan}`, 0);
          }
          if (poeCameraCount + getCameraTotal(fieldProductType, undefined, undefined, true) < 5) {
            setObjectValue(fields, `${secureBusinessOppositeSectionKeysVulcan[name]}.${fivePortPoeSwitchPaidVulcan}`, undefined, 'isVisible');
            setObjectValue(fields, `${secureBusinessOppositeSectionKeysVulcan[name]}.${fivePortPoeSwitchPaidVulcan}`, 0);
          }
        }
        const switchKeyNonZero = formObjectKeys.filter(k => {
          return (
            fields[name][k].productType === typeSwitch &&
            fields[name][k].name === fivePortPoeSwitchPaidVulcan
          );
        });
        if (switchKeyNonZero.length > 0) {
          const camerasTotal = poeCameraCount + getCameraTotal(fieldProductType, true, undefined, undefined);
          for (let i = 0; i < switchKeyNonZero.length; i += 1) {
            fields[name][switchKeyNonZero[i]].isVisible = camerasTotal > 4;
            fields[name][switchKeyNonZero[i]].value = camerasTotal > 4 ? 1 : 0;
          }
        }
        const hidePoeIncludedCamera = checkAllPoeCameraValues();
        if (!hidePoeIncludedCamera) {
          if (radioSelection === 'protect') {
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.value = 0;
          }
          if (radioSelection === 'control') {
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.value = 0;
          }
        }
      } else if (
        checkIfHasSwitchOption() &&
        fieldName.startsWith('easyThreeYear')
      ) {
        if (
          [
            easyThreeYearIndoorCameraVulcan,
            easyThreeYearOutdoorCameraVulcan,
            controlIncludedPoeTurretCameraVulcan
          ].includes(fieldName)
        ) {
          const controlIncludedPoeTurretCameraValue =
            fields[keyControlIncludedEquipmentCameraSelectionVulcan]
              .controlIncludedPaid2TbSvrVulcan.value;

          if (radioSelection === 'control') {
            const cameraSum =
              parseInt(
                fields[keyControlAdditionalEquipmentVulcan]
                  .easyThreeYearIndoorCameraVulcan.value || 0,
                10
              ) +
              parseInt(
                fields[keyControlAdditionalEquipmentVulcan]
                  .easyThreeYearOutdoorCameraVulcan.value || 0,
                10
              );
            if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
              fields[
                keyControlAdditionalEquipmentVulcan
              ].easyThreeYearMicroSdCard128GbVulcan.value = cameraSum;
            } else if (
              cameraSum === 0 ||
              controlIncludedPoeTurretCameraValue >= 1
            ) {
              fields[
                keyControlAdditionalEquipmentVulcan
              ].easyThreeYearMicroSdCard128GbVulcan.value = 0;
            }
          }
        }
        const poeCameraCount = formObjectKeys
          .filter(
            kc =>
              fields[name][kc].productType === typePoeCamera &&
              kc.startsWith('easyThreeYear')
          )
          .reduce(
            (acc, kc) => acc + parseInt(fields[name][kc].value || 0, 10),
            0
          );
        const switchKey = formObjectKeys.filter(
          k =>
            fields[name][k].productType === typeSwitch &&
            fields[name][k].name === easyThreeYearFivePortPoeSwitchVulcan
        );
        const additionalEquipmentPoeCameraArray = [
          protectIncludedPoeTurretCameraVulcan,
          controlIncludedPoeTurretCameraVulcan
        ];
        if (
          additionalEquipmentPoeCameraArray.includes(fieldName) &&
          value > 0
        ) {
          if (radioSelection === 'protect') {
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.isVisible = true;
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.value = 1;
          } else {
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.value = 0;
          }
          if (radioSelection === 'control') {
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.isVisible = true;
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.value = 1;
          } else {
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.value = 0;
          }
        }
        // Show Temperature Probe in three year fields if temperature sensor > 0
        const additionalEquipmentTempSensorArray = [
          temperatureSensorVulcan,
          easyThreeYearTemperatureSensorVulcan,
          easyFiveYearTemperatureSensorVulcan
        ];
        if (additionalEquipmentTempSensorArray.includes(fieldName)) {
          // Handle three-year temperature probes
          if (fieldName === 'easyThreeYearTemperatureSensorVulcan') {
            if (value > 0) {
              if (radioSelection === 'protect') {
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = value;
              }
              if (radioSelection === 'control') {
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = value;
              }
              if (radioSelection === 'monitor') {
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = value;
              }
            } else {
              if (radioSelection === 'protect') {
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = 0;
              }
              if (radioSelection === 'control') {
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = 0;
              }
              if (radioSelection === 'monitor') {
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = 0;
              }
            }
          }

          // Handle five-year temperature probes
          if (fieldName === 'easyFiveYearTemperatureSensorVulcan') {
            if (value > 0) {
              if (radioSelection === 'protect') {
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = value;
              }
              if (radioSelection === 'control') {
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = value;
              }
              if (radioSelection === 'monitor') {
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = value;
              }
            } else {
              if (radioSelection === 'protect') {
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = 0;
              }
              if (radioSelection === 'control') {
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = 0;
              }
              if (radioSelection === 'monitor') {
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = 0;
              }
            }
          }
        }

        if (switchKey.length > 0) {
          for (let i = 0; i < switchKey.length; i += 1) {
            fields[name][switchKey[i]].isVisible = poeCameraCount > 0 && poeCameraCount < 5;
            fields[name][switchKey[i]].value = poeCameraCount > 0 && poeCameraCount < 5 ? 1 : 0;
          }
          fields[keyControlIncludedEquipmentCameraSelectionVulcan][controlIncludedPaid2TbSvrVulcan].value = poeCameraCountAll > 0 ? 1 : 0;
          setSdCard(fields);
        }
        const switchKeyNonZero = formObjectKeys.filter(
          k =>
            fields[name][k].productType === typeSwitch &&
            fields[name][k].name === easyThreeYearFivePortPoeSwitchPaidVulcan
        );
        if (switchKeyNonZero.length > 0) {
          for (let i = 0; i < switchKeyNonZero.length; i += 1) {
            fields[name][switchKeyNonZero[i]].isVisible =
              poeCameraCount +
                getCameraTotal(fieldProductType, true, undefined, undefined) >
              4;
            fields[name][switchKeyNonZero[i]].value =
              poeCameraCount +
                getCameraTotal(fieldProductType, true, undefined, undefined) >
              4
                ? 1
                : 0;
          }
        }
        const hidePoeIncludedCamera = checkAllPoeCameraValues();
        if (!hidePoeIncludedCamera) {
          if (radioSelection === 'protect') {
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.value = 0;
          }
          if (radioSelection === 'control') {
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.value = 0;
          }
        }
      } else if (
        checkIfHasSwitchOption() &&
        fieldName.startsWith('easyFiveYear')
      ) {
        const poeCameraCount = formObjectKeys
          .filter(
            kc =>
              fields[name][kc].productType === typePoeCamera &&
              kc.startsWith('easyFiveYear')
          )
          .reduce(
            (acc, kc) => acc + parseInt(fields[name][kc].value || 0, 10),
            0
          );
        if (
          [
            easyFiveYearIndoorCameraVulcan,
            easyFiveYearOutdoorCameraVulcan,
            controlIncludedPoeTurretCameraVulcan
          ].includes(fieldName)
        ) {
          const controlIncludedPoeTurretCameraValue =
            fields[keyControlIncludedEquipmentCameraSelectionVulcan]
              .controlIncludedPaid2TbSvrVulcan.value;

          if (radioSelection === 'control') {
            const cameraSum =
              parseInt(
                fields[keyControlAdditionalEquipmentVulcan]
                  .easyFiveYearIndoorCameraVulcan.value || 0,
                10
              ) +
              parseInt(
                fields[keyControlAdditionalEquipmentVulcan]
                  .easyFiveYearOutdoorCameraVulcan.value || 0,
                10
              );
            if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
              fields[
                keyControlAdditionalEquipmentVulcan
              ].easyFiveYearMicroSdCard128GbVulcan.value = cameraSum;
            } else if (
              cameraSum === 0 ||
              controlIncludedPoeTurretCameraValue >= 1
            ) {
              fields[
                keyControlAdditionalEquipmentVulcan
              ].easyFiveYearMicroSdCard128GbVulcan.value = 0;
            }
          }
        }
        const switchKey = formObjectKeys.filter(
          k =>
            fields[name][k].productType === typeSwitch &&
            fields[name][k].name === easyFiveYearFivePortPoeSwitchVulcan
        );
        const additionalEquipmentPoeCameraArray = [
          protectIncludedPoeTurretCameraVulcan,
          controlIncludedPoeTurretCameraVulcan
        ];
        if (
          additionalEquipmentPoeCameraArray.includes(fieldName) &&
          value > 0
        ) {
          if (radioSelection === 'protect') {
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.isVisible = true;
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.value = 1;
          } else {
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.value = 0;
          }
          if (radioSelection === 'control') {
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.isVisible = true;
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.value = 1;
          } else {
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.value = 0;
          }
        }
        // Show Temperature Probe in three year fields if temperature sensor > 0
        const additionalEquipmentTempSensorArray = [
          temperatureSensorVulcan,
          easyThreeYearTemperatureSensorVulcan,
          easyFiveYearTemperatureSensorVulcan
        ];
        if (additionalEquipmentTempSensorArray.includes(fieldName)) {
          // Handle three-year temperature probes
          if (fieldName === 'easyThreeYearTemperatureSensorVulcan') {
            if (value > 0) {
              if (radioSelection === 'protect') {
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = value;
              }
              if (radioSelection === 'control') {
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = value;
              }
              if (radioSelection === 'monitor') {
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = value;
              }
            } else {
              if (radioSelection === 'protect') {
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = 0;
              }
              if (radioSelection === 'control') {
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = 0;
              }
              if (radioSelection === 'monitor') {
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyThreeYearTemperatureProbeVulcan.value = 0;
              }
            }
          }

          // Handle five-year temperature probes
          if (fieldName === 'easyFiveYearTemperatureSensorVulcan') {
            if (value > 0) {
              if (radioSelection === 'protect') {
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = value;
              }
              if (radioSelection === 'control') {
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = value;
              }
              if (radioSelection === 'monitor') {
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = true;
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = value;
              }
            } else {
              if (radioSelection === 'protect') {
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyProtectAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = 0;
              }
              if (radioSelection === 'control') {
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyControlAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = 0;
              }
              if (radioSelection === 'monitor') {
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.isVisible = false;
                fields[
                  keyMonitorAdditionalEquipmentVulcan
                ].easyFiveYearTemperatureProbeVulcan.value = 0;
              }
            }
          }
        }

        if (switchKey.length > 0) {
          for (let i = 0; i < switchKey.length; i += 1) {
            fields[name][switchKey[i]].isVisible = poeCameraCount > 0 && poeCameraCount < 5;
            fields[name][switchKey[i]].value = poeCameraCount > 0 && poeCameraCount < 5 ? 1 : 0;
          }
          fields[keyControlIncludedEquipmentCameraSelectionVulcan][controlIncludedPaid2TbSvrVulcan].value = poeCameraCountAll > 0 ? 1 : 0;
          setSdCard(fields);
        }
        const switchKeyNonZero = formObjectKeys.filter(
          k =>
            fields[name][k].productType === typeSwitch &&
            fields[name][k].name === easyFiveYearFivePortPoeSwitchPaidVulcan
        );
        if (switchKeyNonZero.length > 0) {
          for (let i = 0; i < switchKeyNonZero.length; i += 1) {
            fields[name][switchKeyNonZero[i]].isVisible =
              poeCameraCount +
                getCameraTotal(fieldProductType, true, undefined, undefined) >
              4;
            fields[name][switchKeyNonZero[i]].value =
              poeCameraCount +
                getCameraTotal(fieldProductType, true, undefined, undefined) >
              4
                ? 1
                : 0;
          }
        }
        const hidePoeIncludedCamera = checkAllPoeCameraValues();
        if (!hidePoeIncludedCamera) {
          if (radioSelection === 'protect') {
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyProtectIncludedEquipmentCameraSelectionVulcan
            ].protectIncludedPoeSwitchVulcan.value = 0;
          }
          if (radioSelection === 'control') {
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.isVisible = false;
            fields[
              keyControlIncludedEquipmentCameraSelectionVulcan
            ].controlIncludedPoeSwitchVulcan.value = 0;
          }
        }
      }

      if (
        [
          keyControlAdditionalEquipmentVulcan,
          keyProtectAdditionalEquipmentVulcan,
          keyMonitorAdditionalEquipmentVulcan,
          keySecurityCameraEquipment
        ].includes(name)
      ) {
        calculateEquipmentRates(oldValues, fields[name], fieldName);
      }
      setFormFields(fields);
    }
  };

  const countPoeCameras = (paymentType) => {
    const fieldMapping = {
      'onetimePayment': 'poeDomeCamera',
      'threeYearEasyPayment': 'easyThreeYearPoeDomeCameraVulcan',
      'fiveYearEasyPayment': 'easyFiveYearPoeDomeCameraVulcan',
    };
    let poeCameraCount;

    switch (radioSelection) {
      case 'control':
        poeCameraCount =
          _.get(formFields, `${keyControlIncludedEquipmentCameraSelectionVulcan}.${controlIncludedPoeTurretCameraVulcan}.value`, 0) +
          _.get(formFields, `${keyControlAdditionalEquipmentVulcan}.${fieldMapping[paymentType]}.value`, 0);
        break;
      case 'protect':
        poeCameraCount =
          _.get(formFields, `${keyProtectIncludedEquipmentCameraSelectionVulcan}.${protectIncludedPoeTurretCameraVulcan}.value`, 0) +
          _.get(formFields, `${keyProtectAdditionalEquipmentVulcan}.${fieldMapping[paymentType]}.value`, 0);
        break;
      default:
        poeCameraCount = 0;
    }

    return poeCameraCount;
  };

  const countTemperatureSensor = key => {
    let tempSensorCount = 0;

    if (radioSelection === 'monitor') {
      if (key === 'onetimePayment') {
        tempSensorCount =
          formFields[keyMonitorAdditionalEquipmentVulcan][
            temperatureSensorVulcan
          ].value !== undefined
            ? formFields[keyMonitorAdditionalEquipmentVulcan][
                temperatureSensorVulcan
              ].value
            : 0;
      }
      if (key === 'threeYearEasyPayment') {
        tempSensorCount =
          formFields[keyMonitorAdditionalEquipmentVulcan][
            easyThreeYearTemperatureSensorVulcan
          ].value !== undefined
            ? formFields[keyMonitorAdditionalEquipmentVulcan][
                easyThreeYearTemperatureSensorVulcan
              ].value
            : 0;
      }
      if (key === 'fiveYearEasyPayment') {
        tempSensorCount =
          formFields[keyMonitorAdditionalEquipmentVulcan][
            easyFiveYearTemperatureSensorVulcan
          ].value !== undefined
            ? formFields[keyMonitorAdditionalEquipmentVulcan][
                easyFiveYearTemperatureSensorVulcan
              ].value
            : 0;
      }
    }
    if (radioSelection === 'protect') {
      if (key === 'onetimePayment') {
        tempSensorCount =
          formFields[keyProtectAdditionalEquipmentVulcan][
            temperatureSensorVulcan
          ].value !== undefined
            ? formFields[keyProtectAdditionalEquipmentVulcan][
                temperatureSensorVulcan
              ].value
            : 0;
      }
      if (key === 'threeYearEasyPayment') {
        tempSensorCount =
          formFields[keyProtectAdditionalEquipmentVulcan][
            easyThreeYearTemperatureSensorVulcan
          ].value !== undefined
            ? formFields[keyProtectAdditionalEquipmentVulcan][
                easyThreeYearTemperatureSensorVulcan
              ].value
            : 0;
      }
      if (key === 'fiveYearEasyPayment') {
        tempSensorCount =
          formFields[keyProtectAdditionalEquipmentVulcan][
            easyFiveYearTemperatureSensorVulcan
          ].value !== undefined
            ? formFields[keyProtectAdditionalEquipmentVulcan][
                easyFiveYearTemperatureSensorVulcan
              ].value
            : 0;
      }
    }
    if (radioSelection === 'control') {
      if (key === 'onetimePayment') {
        tempSensorCount =
          formFields[keyControlAdditionalEquipmentVulcan][
            temperatureSensorVulcan
          ].value !== undefined
            ? formFields[keyControlAdditionalEquipmentVulcan][
                temperatureSensorVulcan
              ].value
            : 0;
      }
      if (key === 'threeYearEasyPayment') {
        tempSensorCount =
          formFields[keyControlAdditionalEquipmentVulcan][
            easyThreeYearTemperatureSensorVulcan
          ].value !== undefined
            ? formFields[keyControlAdditionalEquipmentVulcan][
                easyThreeYearTemperatureSensorVulcan
              ].value
            : 0;
      }
      if (key === 'fiveYearEasyPayment') {
        tempSensorCount =
          formFields[keyControlAdditionalEquipmentVulcan][
            easyFiveYearTemperatureSensorVulcan
          ].value !== undefined
            ? formFields[keyControlAdditionalEquipmentVulcan][
                easyFiveYearTemperatureSensorVulcan
              ].value
            : 0;
      }
    }
    return tempSensorCount;
  };

  const history = useHistory();

  const currentPath = history.location.pathname.split('/')[3];

  return (
    <>
      {title && <EquipmentSectionTitle>{title}</EquipmentSectionTitle>}
      {subTitle && <EquipmentSectionSubTitle>{subTitle}</EquipmentSectionSubTitle>}
      <div style={{ display: isExpanded ? 'flex' : 'none' }}>
        {formStepFields && (
          <EquipmentSectionWrapper>
            {oneTimePaymentTitle && (
              <EquipmentSectionSubTitle>
                {oneTimePaymentTitle}
              </EquipmentSectionSubTitle>
            )}
            {formFields[name] &&
              formStepFields &&
              formStepFields.map(({ fields, sys: { id: sysId } }, index) => {
                const key = `EquipmentSection${name}${index}`;
                const error = formErrors[name] && formErrors[name][fields.name];
                const hiddenValue = checkIfHasSwitchOption()
                  ? !formFields[name][fields.name].isVisible ||
                    formFields[name][fields.name].isHidden
                  : false;

                // SOF-1582: Non-zero value for POE switch should not be visible
                const poeCameraCount = countPoeCameras('oneTimePayment');
                if (
                  currentPath === 'Vulcan_Form' &&
                  formFields[name][fivePortPoeSwitchPaidVulcan] &&
                  poeCameraCount < 5
                ) {
                  formFields[name][
                    fivePortPoeSwitchPaidVulcan
                  ].isVisible = false;
                }

                const temperatureSensorCount = countTemperatureSensor(
                  'oneTimePayment'
                );
                if (
                  currentPath === 'Vulcan_form' &&
                  formFields[name][temperatureProbeVulcan] &&
                  temperatureSensorCount < 1
                ) {
                  formFields[name][temperatureProbeVulcan].isVisible = false;
                }

                const fieldData = {
                  ...fields,
                  ...formFields[name][fields.name],
                  isHidden: hiddenValue,
                  formFields,
                  sysId,
                  onChange: e => handleFormField(e.target)
                };
                return (
                  <Fragment key={key}>
                    <FormField data={fieldData} />
                    {error && error.text && <Error text={error.text} />}
                  </Fragment>
                );
              })}
          </EquipmentSectionWrapper>
        )}

        {/* 
        Easy Payments are shown/hidden based on boolean value of shouldHideEasyPayments
      */}
        {easyPaymentFields && (
          <EquipmentSectionWrapper>
            {easyPaymentTitle && (
              <EquipmentSectionSubTitle>
                {easyPaymentTitle}
              </EquipmentSectionSubTitle>
            )}
            {formFields[name] &&
              Array.isArray(easyPaymentFields) &&
              easyPaymentFields.map(({ fields, sys: { id: sysId } }, index) => {
                const key = `EquipmentSection${name}${index}`;
                const error = formErrors[name] && formErrors[name][fields.name];
                const hiddenValue = checkIfHasSwitchOption()
                  ? !formFields[name][fields.name].isVisible ||
                    formFields[name][fields.name].isHidden
                  : false;
                // SOF-1582: Non-zero value for POE switch should not be visible
                const poeCameraCount = countPoeCameras('easyPayment');
                if (
                  currentPath === 'Vulcan_form' &&
                  formFields[name][easyThreeYearFivePortPoeSwitchPaidVulcan] &&
                  poeCameraCount < 5
                ) {
                  formFields[name][
                    easyThreeYearFivePortPoeSwitchPaidVulcan
                  ].isVisible = false;
                }
                const temperatureSensorCount = countTemperatureSensor(
                  'easyPayment'
                );
                if (
                  currentPath === 'Vulcan_form' &&
                  formFields[name][easyThreeYearTemperatureProbeVulcan] &&
                  temperatureSensorCount < 1
                ) {
                  formFields[name][
                    easyThreeYearTemperatureProbeVulcan
                  ].isVisible = false;
                }
                const fieldData = {
                  ...fields,
                  ...formFields[name][fields.name],
                  isHidden: hiddenValue,
                  formFields,
                  sysId,
                  onChange: e => handleFormField(e.target)
                };
                return (
                  <Fragment key={key}>
                    <FormField data={fieldData} />
                    {error && error.text && <Error text={error.text} />}
                  </Fragment>
                );
              })}
          </EquipmentSectionWrapper>
        )}

        {/* Showing one time payment fields */}
        {oneTimePaymentFields && (
          <EquipmentSectionWrapper>
            {oneTimePaymentTitleVulcan && (
              <EquipmentSectionSubTitle>
                {oneTimePaymentTitleVulcan}
              </EquipmentSectionSubTitle>
            )}
            {formFields[name] &&
              Array.isArray(oneTimePaymentFields) &&
              oneTimePaymentFields.map(
                ({ fields, sys: { id: sysId } }, index) => {
                  const key = `EquipmentSection${name}${index}`;
                  const error =
                    formErrors[name] && formErrors[name][fields.name];
                  const hiddenValue = checkIfHasSwitchOption()
                    ? !formFields[name][fields.name].isVisible ||
                      formFields[name][fields.name].isHidden
                    : false;
                  // SOF-1582: Non-zero value for POE switch should not be visible
                  const poeCameraCount = countPoeCameras('oneTimePayment');
                  if (
                    currentPath === 'Vulcan_form' &&
                    formFields[name][fivePortPoeSwitchPaidVulcan] &&
                    poeCameraCount < 5
                  ) {
                    formFields[name][
                      fivePortPoeSwitchPaidVulcan
                    ].isVisible = false;
                  }
                  const temperatureSensorCount = countTemperatureSensor(
                    'oneTimePayment'
                  );
                  if (
                    currentPath === 'Vulcan_form' &&
                    formFields[name][temperatureProbeVulcan] &&
                    temperatureSensorCount < 1
                  ) {
                    formFields[name][temperatureProbeVulcan].isVisible = false;
                  }
                  const fieldData = {
                    ...fields,
                    ...formFields[name][fields.name],
                    isHidden: hiddenValue,
                    formFields,
                    sysId,
                    onChange: e => handleFormField(e.target)
                  };
                  return (
                    <Fragment key={key}>
                      <FormField data={fieldData} />
                      {error && error.text && <Error text={error.text} />}
                    </Fragment>
                  );
                }
              )}
          </EquipmentSectionWrapper>
        )}

        {/* Showing 3Y easy payment fields */}
        {threeYearEasyPaymentFields && (
          <EquipmentSectionWrapper>
            {threeYearEasyPaymentTitle && (
              <EquipmentSectionSubTitle>
                {threeYearEasyPaymentTitle}
              </EquipmentSectionSubTitle>
            )}
            {formFields[name] &&
              Array.isArray(threeYearEasyPaymentFields) &&
              threeYearEasyPaymentFields.map(
                ({ fields, sys: { id: sysId } }, index) => {
                  const key = `EquipmentSection${name}${index}`;
                  const error =
                    formErrors[name] && formErrors[name][fields.name];
                  const hiddenValue = checkIfHasSwitchOption()
                    ? !formFields[name][fields.name].isVisible ||
                      formFields[name][fields.name].isHidden
                    : false;

                  // SOF-1582: Non-zero value for POE switch should not be visible
                  const poeCameraCount = countPoeCameras(
                    'threeYearEasyPayment'
                  );
                  if (
                    currentPath === 'Vulcan_form' &&
                    formFields[name][
                      easyThreeYearFivePortPoeSwitchPaidVulcan
                    ] &&
                    poeCameraCount < 5
                  ) {
                    formFields[name][
                      easyThreeYearFivePortPoeSwitchPaidVulcan
                    ].isVisible = false;
                  }
                  const temperatureSensorCount = countTemperatureSensor(
                    'threeYearEasyPayment'
                  );
                  if (
                    currentPath === 'Vulcan_form' &&
                    formFields[name][easyThreeYearTemperatureProbeVulcan] &&
                    temperatureSensorCount < 1
                  ) {
                    formFields[name][
                      easyThreeYearTemperatureProbeVulcan
                    ].isVisible = false;
                  }
                  const fieldData = {
                    ...fields,
                    ...formFields[name][fields.name],
                    isHidden: hiddenValue,
                    formFields,
                    sysId,
                    onChange: e => handleFormField(e.target)
                  };
                  return (
                    <Fragment key={key}>
                      <FormField data={fieldData} />
                      {error && error.text && <Error text={error.text} />}
                    </Fragment>
                  );
                }
              )}
          </EquipmentSectionWrapper>
        )}

        {/* Showing 5Y easy payment fields for vulcan */}
        {fiveYearEasyPaymentFields && (
          <EquipmentSectionWrapper>
            {fiveYearEasyPaymentTitle && (
              <EquipmentSectionSubTitle>
                {fiveYearEasyPaymentTitle}
              </EquipmentSectionSubTitle>
            )}
            {formFields[name] &&
              Array.isArray(fiveYearEasyPaymentFields) &&
              fiveYearEasyPaymentFields.map(
                ({ fields, sys: { id: sysId } }, index) => {
                  const key = `EquipmentSection${name}${index}`;
                  const error =
                    formErrors[name] && formErrors[name][fields.name];
                  const hiddenValue = checkIfHasSwitchOption()
                    ? !formFields[name][fields.name].isVisible ||
                      formFields[name][fields.name].isHidden
                    : false;

                  // SOF-1582: Non-zero value for POE switch should not be visible
                  const poeCameraCount = countPoeCameras('fiveYearEasyPayment');
                  if (
                    currentPath === 'Vulcan_form' &&
                    formFields[name][easyFiveYearFivePortPoeSwitchPaidVulcan] &&
                    poeCameraCount < 5
                  ) {
                    formFields[name][
                      easyFiveYearFivePortPoeSwitchPaidVulcan
                    ].isVisible = false;
                  }
                  const temperatureSensorCount = countTemperatureSensor(
                    'fiveYearEasyPayment'
                  );
                  if (
                    currentPath === 'Vulcan_form' &&
                    formFields[name][easyFiveYearTemperatureProbeVulcan] &&
                    temperatureSensorCount < 1
                  ) {
                    formFields[name][
                      easyFiveYearTemperatureProbeVulcan
                    ].isVisible = false;
                  }
                  const fieldData = {
                    ...fields,
                    ...formFields[name][fields.name],
                    isHidden: hiddenValue,
                    formFields,
                    sysId,
                    onChange: e => handleFormField(e.target)
                  };
                  return (
                    <Fragment key={key}>
                      <FormField data={fieldData} />
                      {error && error.text && <Error text={error.text} />}
                    </Fragment>
                  );
                }
              )}
          </EquipmentSectionWrapper>
        )}
      </div>
      <Modal
        heading="Alert"
        isOpen={isAlert}
        bodyText={bodyText}
        onClose={() => setIsAlertOpen(false)}
      />
    </>
  );
};

EquipmentSectionForm.propTypes = {
  data: PropTypes.shape({
    formStepFields: PropTypes.arrayOf(PropTypes.object),
    easyPaymentFields: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string,
    subTitle: PropTypes.string,
    maxValue: PropTypes.number,
    isLimitCameraOnly: PropTypes.bool,
    name: PropTypes.string.isRequired,
    oneTimePaymentTitle: PropTypes.string.isRequired,
    oneTimePaymentTitleVulcan: PropTypes.string.isRequired,
    threeYearEasyPaymentTitle: PropTypes.string.isRequired,
    fiveYearEasyPaymentTitle: PropTypes.string.isRequired,
    easyPaymentTitle: PropTypes.string.isRequired,
    oneTimePaymentFields: PropTypes.arrayOf(PropTypes.object),
    fiveYearEasyPaymentFields: PropTypes.arrayOf(PropTypes.object),
    threeYearEasyPaymentFields: PropTypes.arrayOf(PropTypes.object)
  }).isRequired,
  formErrors: PropTypes.objectOf(PropTypes.object),
  formFields: PropTypes.objectOf(PropTypes.object).isRequired,
  setFormFields: PropTypes.func.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  setIsFormTouched: PropTypes.func.isRequired,
  equipmentTotalPrice: PropTypes.shape({
    subtractAmountFromPrice: PropTypes.number.isRequired,
    addAmountToPrice: PropTypes.number.isRequired,
    addAmountToMonthly: PropTypes.number.isRequired,
    monthlyPayment: PropTypes.number.isRequired
  }).isRequired,
  setEquipmentTotalPrice: PropTypes.func.isRequired,
  hardwareDiscountAmount: PropTypes.number.isRequired,
  setHadwareDiscountAmount: PropTypes.func.isRequired,
  dueNow: PropTypes.number.isRequired,
  setDueNow: PropTypes.func.isRequired,
  isHardwareDiscount: PropTypes.func.isRequired
};

EquipmentSectionForm.defaultProps = {
  formErrors: {}
};

export default EquipmentSectionForm;
